import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";

//Modules
import { SharedModule } from "../shared/shared.module";
import { NgxMaskModule, IConfig } from "ngx-mask";
export let options: Partial<IConfig> | (() => Partial<IConfig>);

//Components
//Login
import { LoginExecutiveComponent } from "./login/login-executive/login-executive.component";
import { LoginComponent } from "../auth/login/login.component";
import { LoginCompanyComponent } from "./login/login-company/login-company.component";
//Account
import { CreateAccountComponent } from "./account/create-account.component";
import { CreateCompanyComponent } from "./account/create-company/create-company.component";
import { CreateAdminComponent } from "./account/create-admin/create-admin.component";
import { CreateAccountSuccessComponent } from "./account/create-account-success/create-account-success.component";
import { CreatePasswordComponent } from "./password/create-password/create-password.component";
import { EnterCodeComponent } from "./password/enter-code/enter-code.component";
import { NewPasswordComponent } from "./password/new-password/new-password.component";
import { NewPasswordSuccessComponent } from "./password/new-password/new-password-success/new-password-success.component";
import { RecoverPasswordComponent } from "./password/recover-password/recover-password.component";
import { AdminDataComponent } from "./password/recover-password/admin-data/admin-data.component";

//Services
import { AccountService } from "../services/account.service";
import { StepperService } from "../services/stepper.service";

//Routes
import { AUTH_ROUTING } from "./auth.routing.module";

@NgModule({
  declarations: [
    LoginExecutiveComponent,
    LoginComponent,
    LoginCompanyComponent,
    CreateAccountComponent,
    CreateCompanyComponent,
    CreateAdminComponent,
    CreateAccountSuccessComponent,
    CreatePasswordComponent,
    EnterCodeComponent,
    NewPasswordComponent,
    NewPasswordSuccessComponent,
    RecoverPasswordComponent,
    AdminDataComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AUTH_ROUTING,
    SharedModule,
    NgxMaskModule.forRoot(),
  ],
  providers: [AccountService, StepperService],
})
export class AuthModule {}
